module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/fv-bg-sp-6b7342aa7ddbb3d1e33b270bfb225198.jpg";